import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "manual-address-option__text" }

import dictionary from "@/i18n/dictionary.json";
import IconPlus from "@/components/icons/IconPlus.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckoutManualAddressOption',
  emits: {
  click: () => {
    return true;
  },
},
  setup(__props, { emit }) {


const onClick = () => {
  emit("click");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "manual-address-option",
    type: "button",
    onClick: onClick
  }, [
    _createVNode(IconPlus, { class: "manual-address-option__icon" }),
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t(_unref(dictionary).form.otherBillingAddress)), 1)
  ]))
}
}

})